import { LoaderCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { errorMessage } from '../../lib/api/query-client';
import { cn } from '../../lib/cn';
import { Button } from './Button';

export function Loading({ label = 'Loading', className }: { label?: string; className?: string }) {
  return (
    <p role="status" className={cn('flex items-center gap-2.5 px-4 py-10 text-muted', className)}>
      <LoaderCircle className="size-5 animate-spin text-accent" aria-hidden />
      {label}…
    </p>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div role="alert" className="flex flex-col items-start gap-3 rounded-2xl bg-surface p-5">
      <p className="font-medium text-danger">{errorMessage(error)}</p>
      {onRetry && (
        <Button size="sm" variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  children?: ReactNode;
}

export function EmptyState({ icon, title, children }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl bg-surface px-6 py-10 text-center">
      {icon && (
        <span className="flex size-12 items-center justify-center rounded-2xl bg-accent-soft text-accent [&_svg]:size-6">
          {icon}
        </span>
      )}
      <p className="heading max-w-sm text-lead">{title}</p>
      {children}
    </div>
  );
}
